import { MfaCard } from "@/features/impostazioni/MfaCard";
import { logout } from "./api";

/**
 * Pagina piena per chi entra senza secondo fattore quando è obbligatorio
 * (`OM_MFA_OBBLIGATORIA`, richiesto dalla Data Protection Policy Amazon).
 *
 * Il backend lascia passare solo `/me`, l'attivazione e il logout: mostrare
 * l'app normale vorrebbe dire una schermata piena di errori 403. Ad attivazione
 * riuscita si ricarica, così `/me` riparte pulito e l'app monta da capo.
 */
export function AttivaMfaPage() {
  async function esci() {
    try {
      await logout();
    } finally {
      window.location.assign("/login");
    }
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-paper-2 px-4 py-10">
      <div className="w-full max-w-[440px]">
        <h1 className="mb-2 text-center font-serif text-[24px] font-medium tracking-tight text-ink">
          Attiva l'accesso a due fattori
        </h1>
        <p className="mb-6 text-center text-[13px] leading-relaxed text-ink-3">
          Da ora serve per entrare in Order Manager. Ti basta l'app di autenticazione sul telefono
          (Google Authenticator, Microsoft Authenticator o simili).
        </p>
        <MfaCard onAttivata={() => window.location.reload()} />
        <button
          type="button"
          onClick={() => void esci()}
          className="mx-auto mt-4 block rounded text-[12px] font-medium text-ink-3 transition-colors duration-150 hover:text-accent-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft"
        >
          Esci
        </button>
      </div>
    </main>
  );
}
